import React, { memo } from "react";
import { useShowProductPictures } from "stores/project";
import { Icon } from "components/Icon/Icon";
import { useProductImage } from "hooks";

type ProductImageProps = {
  pimId: string;
  productImagesDisabled: boolean;
  productName: string;
  width: number;
  height: number;
};

export const ProductImage = memo(
  ({
    pimId,
    productImagesDisabled,
    productName,
    width,
    height,
  }: ProductImageProps) => {
    const showProductPictures = useShowProductPictures();
    const { productImage, fetching } = useProductImage(pimId);
    if (!showProductPictures || productImagesDisabled) {
      return;
    }

    return (
      <div className="icon-64 d-flex align-items-center justify-content-center">
        {productImage ? (
          <img
            src={productImage}
            width={width}
            height={height}
            className="w-100 h-100 object-fit-contain m-0"
            alt={productName}
          />
        ) : (
          <>
            {!pimId || fetching ? (
              <Icon className="icon-64 m-2" iconName="squares-light" />
            ) : null}
          </>
        )}
      </div>
    );
  },
);
